//react
import React from "react";

// styles
import withStyles from "@material-ui/core/styles/withStyles";
import landingPageStyle from "assets/jss/material-kit-pro-react/views/errorPageStyle.jsx";

// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

const dashboardRoutes = [];

class ErrorPage extends React.Component {

  
  render() {
    const { classes, ...rest } = this.props;

    const intercom = document.createElement("script");
    intercom.innerHTML = 'window.Intercom("boot",{ app_id: "l0gl1yia" });';
    document.body.appendChild(intercom);

    return (

      <div>
        <Header
          color="dark"
          routes={dashboardRoutes}
          brand="All Things EQ"
          links={<HeaderLinks />}
          fixed
          changeColorOnScroll={{
            height: 200,
            color: "dark"
          }}
          {...rest}
        />
        
        
        <div className={classes.section} >
          <div style={{backgroundColor:"black", opacity:"0.5", position:"fixed", top:50, left:0, right:0, bottom:0}}>

          </div>
          <div style={{margin:"auto", width:"50%", textAlign:"center", zIndex:100 }}>
            <div className={classes.title}>
              PAGE NOT FOUND
            </div>
            <div className={classes.subtitle}>
              Please check the address and try again.
            </div>
          </div>
        </div>  

        <Footer
          content={
            <div>
              <div className={classes.left}>
                <List className={classes.list}>
                  <ListItem className={classes.inlineBlock}>
                    <a
                      href="https://app.allthingseq.com/"
                      className={classes.block}
                    >
                      All Things E.Q.
                    </a>
                  </ListItem>
                  
                </List>
              </div>
              <div className={classes.right} style={{fontSize:"12px"}}>
                &copy; {1900 + new Date().getYear()}{" "}
                AVA School Solutions
              </div>
            </div>
          }
        />
      </div>
    );
  }
}


export default withStyles(landingPageStyle)(ErrorPage);


// WEBPACK FOOTER //
// ./src/views/ErrorPage/ErrorPage.jsx